import { useTranslation } from "react-i18next";
import { Button, Card, CardContent, CardHeader, CardTitle, CardDescription } from "@tabipla/ui";
import { Sparkles, Users, Wallet, ArrowRight } from "lucide-react";

interface FeatureHighlightsProps {
  onCreateTrip: () => void;
}

export function FeatureHighlights({ onCreateTrip }: FeatureHighlightsProps) {
  const { t } = useTranslation();

  const features = [
    {
      icon: Sparkles,
      iconBg: "bg-purple-100 dark:bg-purple-900/50",
      iconColor: "text-purple-600 dark:text-purple-400",
      title: t("home.featureHighlights.ai.title"),
      description: t("home.featureHighlights.ai.description"),
    },
    {
      icon: Users,
      iconBg: "bg-blue-100 dark:bg-blue-900/50",
      iconColor: "text-blue-600 dark:text-blue-400",
      title: t("home.featureHighlights.group.title"),
      description: t("home.featureHighlights.group.description"),
    },
    {
      icon: Wallet,
      iconBg: "bg-emerald-100 dark:bg-emerald-900/50",
      iconColor: "text-emerald-600 dark:text-emerald-400",
      title: t("home.featureHighlights.expense.title"),
      description: t("home.featureHighlights.expense.description"),
    },
  ];

  return (
    <Card className="overflow-hidden border-primary/20 bg-gradient-to-br from-primary/5 via-background to-purple-500/5">
      <CardHeader className="pb-2">
        <CardTitle className="flex items-center gap-2 text-lg">
          <Sparkles className="h-5 w-5 text-primary" />
          {t("home.featureHighlights.title")}
        </CardTitle>
        <CardDescription>{t("home.featureHighlights.subtitle")}</CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        {/* Feature list */}
        <div className="space-y-3">
          {features.map((feature, index) => (
            <div
              key={index}
              className="flex items-start gap-3 rounded-lg bg-background/50 p-3 backdrop-blur-sm"
            >
              <div
                className={`flex h-10 w-10 shrink-0 items-center justify-center rounded-full ${feature.iconBg}`}
              >
                <feature.icon className={`h-5 w-5 ${feature.iconColor}`} />
              </div>
              <div className="min-w-0 flex-1">
                <p className="font-medium">{feature.title}</p>
                <p className="text-sm text-muted-foreground">{feature.description}</p>
              </div>
            </div>
          ))}
        </div>

        {/* CTA Button */}
        <Button onClick={onCreateTrip} className="w-full" size="lg">
          {t("home.featureHighlights.cta")}
          <ArrowRight className="ml-2 h-4 w-4" />
        </Button>
      </CardContent>
    </Card>
  );
}
